import React from 'react';
import {
  DataTable, IconTrash,
} from '@skf/bt-wind-rail-commonlibrary';
import style from './RoleManagementAddDataTable.module.scss';
import { useTranslation } from 'react-i18next';

interface IRoleManagementListTableProps {
  userWebRoles?: string[];
  onRemove?: (userWebRole: string) => void;
}

const RoleManagementAddDataTable: React.FunctionComponent<IRoleManagementListTableProps> = (
  {
    userWebRoles = [],
    onRemove = () => ''
  }
) => {
  const { t } = useTranslation();

  const columns: any[] = [
    {
      Header: t('Name'),
      accessor: 'userWebRole',
      className: style.columnName,
    },
    {
      Header: '',
      accessor: 'Action',
      disableSortBy: true,
      className: style.columnActions,
      Cell: ({ row: { original: { userWebRole } } }: any) => {
        return (
          <div className={style.iconsColumns}>
            <IconTrash
              className={style.cursorPointer}
              onClick={() => onRemove(userWebRole)}
            />
          </div>
        );
      },
    },
  ];

  return (
    <DataTable
      columns={columns}
      data={userWebRoles?.map(userWebRole => ({ userWebRole }))}
      className={style.table}
      pagination={20}
    />
  );
};

export default RoleManagementAddDataTable;
